import { setRef } from '@costar-ui/utils';
import { useMemo } from 'react';

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useMemo(function () {
    return function (refValue) {
      refA && setRef(refA, refValue);
      refB && setRef(refB, refValue);
    };
  }, [refA, refB]);
}

export { useForkRef as default };
//# sourceMappingURL=use-fork-ref.esm.js.map
